import React from "react";

import About from "../components/About";
import BackToTop from "../components/BackToTop";
import Contact from "../components/Contact";
import Footer from "../Layout/Footer";
import FooterAlt from "../Layout/FooterAlt";
import Services from "../components/Services";

const Layout = (props) => {
  return (
    <React.Fragment>
      {props.children}
      <About />
      <Services />
      <Contact />
      <Footer />
      <FooterAlt />
      <BackToTop />
    </React.Fragment>
  );
};

export default Layout;
